'use client'

import * as React from 'react'
import { motion } from 'framer-motion'
import { cn } from '../../utils/cn'
import { Children, cloneElement, isValidElement } from 'react'

interface StaggerChildrenProps {
  children: React.ReactNode
  staggerDelay?: number
  className?: string
}

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1,
    },
  },
}

const itemVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: [0.25, 0.1, 0.25, 1],
    },
  },
}

export function StaggerChildren({
  children,
  staggerDelay = 0.1,
  className
}: StaggerChildrenProps) {
  return (
    <motion.div
      variants={{
        ...containerVariants,
        visible: {
          ...containerVariants.visible,
          transition: {
            staggerChildren: staggerDelay,
          },
        },
      }}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, margin: '-50px' }}
      className={cn(className)}
    >
      {/* eslint-disable-next-line @typescript-eslint/no-explicit-any */}
      {Children.map(children, (child) => {
        if (isValidElement(child)) {
          return (
            <motion.div variants={itemVariants} className="h-full">
              {cloneElement(child) as any}
            </motion.div>
          )
        }
        return child
      }) as any}
    </motion.div>
  )
}
